<jw-modal id="transportRowCreationModal">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <h1 class='header'>Create a new unit</h1>
  <div class="form-row">
    <div class="form-group">
      <input type="radio" checked name='group[]' (change)="this.onOptionSelect($event, 'own')"/>
      <label for="inputEmail4">&nbsp;&nbsp;Own Vehicle</label>
    </div>
    <div class="form-group">
      &nbsp;&nbsp;<input type="radio" name='group[]' (change)="this.onOptionSelect($event, 'sub')"/>
      <label for="inputEmail4">&nbsp;&nbsp;Subcontractor</label>
    </div>
  </div>
  <div class="form-row">
    @if (this.roundOption === "own") {
      <div class="form-group col-md-4">
        <label for="inputEmail4">Name</label>
        <input type="text" [(ngModel)]='this.jobAssignment.name' [class.is-invalid]='!this.jobAssignment.name' name='name' class="form-control" id="inputEmail4">
      </div>
    }
    <div class="form-group col-md-4">
      <label for="inputEmail4">Depot</label>
      <ng-select [(ngModel)]="this.jobAssignment.depotId" [class.is-invalid]='this.jobAssignment.depotId === -1' (change)='onDepotChanged($event)'>
        @for (depot of this.depots; track depot) {
          <ng-option [value]='depot.id'>{{ depot.name }}</ng-option>
        }
      </ng-select>
    </div>
    <!-- <div class="form-group col-md-4">
    <label for="inputEmail4" [class.is-invalid]='!this.jobAssignment.driverStartTime'>Driver Start Time</label>
    <input type="time" [(ngModel)]='this.jobAssignment.driverStartTime' name='name' class="form-control" id="inputEmail4">
  </div> -->
  @if (this.jobAssignment.depotId !== -1 && this.roundOption === "own") {
    <div class="form-group col-md-4">
      <label for="inputEmail4">Driver</label>
      <ng-select [(ngModel)]='this.jobAssignment.driverId'  [class.is-invalid]='this.jobAssignment.driverId === -1' (change)='this.jobAssignment.driverId = +$event; this.jobAssignment.driver.id = this.jobAssignment.driverId'>
        @for (driver of this.drivers; track driver) {
          <ng-option [value]='driver.id'>{{ driver.firstName + ' ' + driver.lastName }}</ng-option>
        }
      </ng-select>
    </div>
  }
  @if (this.jobAssignment.depotId !== -1 && this.roundOption === "own") {
    <div class="form-group col-md-4">
      <label for="inputEmail4">Vehicle</label>
      <ng-select [(ngModel)]='this.jobAssignment.vehicleId' (change)='this.jobAssignment.vehicleId = +$event; this.jobAssignment.vehicle.id = this.jobAssignment.vehicleId; updateNameFromVehicle();'>
        @for (vehicle of this.vehicles; track vehicle) {
          <ng-option [value]='vehicle.id'>{{ vehicle.registration }}</ng-option>
        }
      </ng-select>
    </div>
  }
  @if (this.jobAssignment.depotId !== -1 && this.roundOption === "own" && this.orderTypeId === 4) {
    <div class="form-group col-md-4">
      <label for="inputEmail4">Trailers</label>
      <ng-select [(ngModel)]='this.jobAssignment.trailerId' (change)='this.jobAssignment.trailerId = +$event; this.jobAssignment.trailer.id = this.jobAssignment.trailerId'>
        @for (vehicle of this.trailers; track vehicle) {
          <ng-option [value]='vehicle.id'>{{ vehicle.registration }}</ng-option>
        }
      </ng-select>
    </div>
  }
  @if (this.roundOption === "sub") {
    <div class="form-group col-md-4">
      <label for="inputEmail4">Subcontractor</label>
      <ng-select [class.is-invalid]='this.jobAssignment.subcontractorId === -1' (change)='this.jobAssignment.subcontractorId = +$event; this.jobAssignment.subcontractor.id = this.jobAssignment.subcontractorId; setNameFromSub()'>
        @for (sub of this.subcontractors; track sub) {
          <ng-option [value]='sub.id'>{{ sub.name }}</ng-option>
        }
      </ng-select>
    </div>
  }

  @if (this.roundOption === "sub") {
    <div class="form-group col-md-4">
      <label for="inputEmail4">Number of units</label>
      <input type="number" [(ngModel)]='this.qty' name='name' class="form-control" id="inputEmail4">
    </div>
  }
</div>

<button class='btn btn-success' (click)='this.save()'>Save</button>&nbsp;
<button class='btn btn-danger' (click)='this.cancel()'>Cancel</button>
</jw-modal>
